<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'
import ListOfObjects from "@/views/product/components/product-card/composition/components/ListOfObjects.vue";

export default {
    components: {ListOfObjects, BFormGroup, vSelect},
    props: {
        readOnly: {
            default: false,
        },
        value: {},
        config: {
            type: Object,
            default() {
                return {
                    data: []
                };
            }
        }
    },
    data() {
        return {
            exemption: this.value
        };
    },
    methods: {
        change() {
            this.$emit('input', this.exemption);
        }
    },
    watch: {
        value() {
            this.exemption = this.value;
        }
    }
}
</script>

<template>
    <div>
        <div v-if="readOnly" class="pb-1">
            <h5>{{ $t('Component(CompositionSubstance):rohs-exemption') }}</h5>
            <div v-if="!exemption || exemption.length === 0">-</div>
            <div v-else>
                <div v-for="el in exemption">{{ el }}</div>
            </div>
        </div>
        <div v-else>
            <b-form-group :label="$t('Component(CompositionSubstance):rohs-exemption')">
                <v-select
                    :taggable="true"
                    v-model="exemption"
                    multiple
                    :title="$t('Component(CompositionSubstance):rohs-exemption')"
                    :options="config.data"
                    :placeholder="$t('Component(CompositionSubstance):rohs-exemption')"
                    :disabled="readOnly"
                    @input="change"
                >
                    <template v-slot:no-options="{ search, searching }">
                        {{ $t('Component(CompositionSubstance):multi-exemption-no-options') }}
                    </template>
                </v-select>
            </b-form-group>
        </div>
    </div>
</template>
